import { MailIcon, NotificationIcon } from '@nimbus-ds/icons';
import { MenuButton } from '@nimbus-ds/patterns';
import { useTranslation } from 'react-i18next';
import { useLocation, Link } from 'react-router-dom';
import { NEW_ADMIN_WHATSAPP_NOTIFICATIONS } from 'App/featuresFlags';
import { useHandleMenuClick, useHasTags } from 'App/hooks';
import { configurationsRoutes } from 'domains/Configurations';
import { trackingMenuSecondaryNotificationsClick } from '../tracking';

export function NotificationsMenu() {
  const { t } = useTranslation('common');
  const { pathname } = useLocation();
  const { handleClickItem } = useHandleMenuClick();
  const [hasWhatsappNotifications] = useHasTags([
    NEW_ADMIN_WHATSAPP_NOTIFICATIONS,
  ]);

  const handleClickNewAdmin = () => {
    trackingMenuSecondaryNotificationsClick();
    handleClickItem();
  };

  return (
    <MenuButton
      as={Link}
      to={configurationsRoutes.notifications}
      startIcon={hasWhatsappNotifications ? NotificationIcon : MailIcon}
      onClick={handleClickNewAdmin}
      active={pathname.startsWith(configurationsRoutes.notifications)}
      label={t(
        `settingsMenu.communication.${
          hasWhatsappNotifications ? 'notifications' : 'email'
        }`,
      )}
    />
  );
}
